<template>
  <div v-if="isComponentVisible" class="tech-support-contacts">

    <div v-if="isTelegramVisible" class="tech-support-contact">
      <a :href="`https://t.me/${managingCompanyInfo.telegram}`" target="_blank">
        <v-icon small class="mr-2 telegram-icon">fab fa-telegram-plane</v-icon>
        <span class="link-text">Telegram</span>
      </a>
    </div>

    <div v-if="isViberVisible" class="tech-support-contact">
      <a :href="`viber://chat?number=${managingCompanyInfoViber}`" target="_blank">
        <v-icon small class="mr-2 viber-icon">fab fa-viber</v-icon>
        <span class="link-text">Viber</span>
      </a>
    </div>

    <v-divider v-if="isSocialMediaVisible" class="tech-support-contact"></v-divider>

    <div v-if="isEmailVisible" class="tech-support-contact">
      <a :href="`mailto:${managingCompanyInfo.emailSupport}`">
        <v-icon class="mr-2">far fa-envelope</v-icon>
        <span class="link-text">{{ managingCompanyInfo.emailSupport }}</span>
      </a>
    </div>

    <div v-if="isPhoneVisible" class="tech-support-contact">
      <a :href="`tel:${managingCompanyInfo.phoneSupport}`">
        <v-icon class="mr-2">fa-phone</v-icon>
        <span class="link-text">{{ managingCompanyInfo.phoneSupport }}</span>
      </a>
    </div>

  </div>

</template>

<script>
import { globalSettingsHelper } from '@/helpers/settings-helper';

export default {
  name: 'AppTechSupportContacts',
  computed: {
    managingCompanyInfo() { return globalSettingsHelper.managingCompanyInfo; },
    isTelegramVisible() { return !!globalSettingsHelper.managingCompanyInfo.telegram; },
    isViberVisible() { return !!globalSettingsHelper.managingCompanyInfo.viber; },
    isSocialMediaVisible() { return this.isTelegramVisible || this.isViberVisible; },
    isEmailVisible() { return !!globalSettingsHelper.managingCompanyInfo.emailSupport; },
    isPhoneVisible() { return !!globalSettingsHelper.managingCompanyInfo.phoneSupport; },
    isComponentVisible() { return this.isSocialMediaVisible || this.isEmailVisible || this.isPhoneVisible; },
    managingCompanyInfoViber() {
      return (this.managingCompanyInfo.viber || '')
        .replaceAll('+', '')
        .replaceAll(' ', '');
    }
  }
};
</script>

<style lang="scss">
.tech-support-contacts {

  width: auto;

  .tech-support-contact {
    cursor: pointer;
    margin-top: 8px;

    a {
      color: var(--v-app-colors-text-base);
      text-decoration: none;
    }

    &:hover a .link-text {
      text-decoration: underline;
    }
  }
}
</style>
